import GenericPromptDialog from "./GenericPromptDialog/GenericPromptDialog";
import { archiveRoute } from "../../ducks/routes";
import { useAppDispatch } from "../../redux-store";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import useNavigateToRoute from "../../hooks/useNavigateToRoute";

const EndRouteDialogPrompt = (props: {
  route: {
    routeId: string;
    routeRef: string | null;
  };
  onClose: () => void;
}) => {
  const { route, onClose } = props;
  const { routeId, routeRef } = route;
  const { t } = useTranslation("modals");

  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const navigateToRoute = useNavigateToRoute();

  const onContinueClick = () => {
    dispatch(archiveRoute({ id: routeId }))
      .unwrap()
      .then(() => {
        // Same as the "End route" button: don't leave the archived route open
        if (pathname === `/dispatching/routes/${routeId}`) {
          navigateToRoute(null);
        }
        onClose();
      })
      .catch(() => {
        // The archiveRoute thunk has already reported it and shown the error toast.
      });
  };

  return (
    <GenericPromptDialog
      title={t("endRouteWithInvoicedCargos.title")}
      text={t("endRouteWithInvoicedCargos.text", { routeRef: routeRef ?? "" })}
      continueText={t("endRouteWithInvoicedCargos.continueText")}
      continueButtonColor="primary"
      onContinueClick={onContinueClick}
      onCancelClick={onClose}
      focusOnContinueButton
    />
  );
};

export default EndRouteDialogPrompt;
